const GettingStarted = function() {

    var _ = this;

    // Function to toggle Shopify sections visibility
    function toggleShopifySections(stepNumber) {
        // Get all reviews sections elements
        const shopifySections = document.querySelectorAll('.shopify-section');
        
        shopifySections.forEach(section => {
            // Skip the main getting-started section itself
            if (section.id.includes('__main')) {
                return;
            }
            
            // Hide all other sections except on step 4
            if (stepNumber === 4) {
                section.style.display = 'block';
                section.style.visibility = 'visible';
                section.style.opacity = '1';
            } else {
                section.style.display = 'none';
                section.style.visibility = 'hidden';
                section.style.opacity = '0';
            }
        });
    }
    function GettingStarted() {
        this.selector = {
            main: document.querySelector(".main-getting-started"),
            form: document.querySelector(".main-getting-started .content-steps .step-1-container form.form-step"),
            text_generated: document.querySelectorAll(".main-getting-started .content-steps .step-image .text-render .generated"),
            steps: document.querySelectorAll(".main-getting-started .header-steps .step"),
            backButtons: document.querySelectorAll(".back-button"),
            selectplan: document.querySelectorAll(".main-getting-started .step-2-container .selling-plan-container .selling-plan-item .content, .main-getting-started .step-2-container .selling-plan-container .selling-plan-item label"),
            continueplan: document.querySelector(".main-getting-started .step-2-container .action .continue-plan"),
            selectbundle: document.querySelectorAll(".main-getting-started .step-3-container .form-step-bundle .bundle-item .checkbox input[type=checkbox]"),
            cartdrawer: document.getElementById("sidebar-component-for-cart"),
            cancelbundle: document.querySelector(".main-getting-started .step-3-container .action .cancel"),
            addtocart: document.querySelector(".main-getting-started .step-4-container .form-step-review .action .add-to-cart"),
            reviewitems: document.querySelectorAll(".main-getting-started .step-4-container .form-step-review .review-container .review-item .checkbox input[type=checkbox]"),
            finalsecondproduct: document.querySelector(".main-getting-started .step-4-container .review-container .review-item .content .second-product-variants"),
            finalfifthproduct: document.querySelector(".main-getting-started .step-4-container .review-container .review-item .content .fifth-product-variants"),
            reviewInputs: document.querySelectorAll(".main-getting-started .step-4-container .review-container .review-item .review-input")
        }
        this.state = {
            firstname: '',
            lastname: '', // Added back
            mainitem: { "id": null, 
                        "selling_plan": null, 
                        "bgcolor": null, 
                        "discount": null, 
                        "freebox": false, 
                        "freeshipping": false, 
                        "promo": false,
                        "promocode": null,
                        "showsave": false,
                        "label": null,
                        "price": 0
                    },
            
            bundleItems: [],

            bundleitem: { "id": null, 
                          "selling_plan": null,
                          "bg_image": null,
                          "price": 0,
                          "title": '',
                          "compate_at_price": ''
                        },
            addbundle: false,
            limited_time_offer: limited_time_offer // global variable from main-getting-started.liquid
        }

        // Begin preparing the cart before the final checkout click.
        // The existing flow always clears the cart, so doing it while the
        // customer reviews Boost items removes a full wait at checkout.
        this.cartPreparationPromise = null;
        this.review = {
            mainitem: {
                checkbox: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .checkbox"),
                label: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .checkbox label"),
                price: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .content .header .title"),
                freeshipping: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .content .header .description"),
                freebox: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .content .sub-header"),
                promo: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .content .promo-description"),
                promocode: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .content .promo-description .code"),
                promotitle: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .content .promo-description .title"),
                saved: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .save-details"),
                savedamount: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-main-item] .save-details .amount"),
            },
            bundleitem: {
                checkbox: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-bundle-item] .checkbox"),
                label: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-bundle-item] .checkbox label"),
                input: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-bundle-item] .checkbox input"),
                price: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-bundle-item] .content .header .title"),
                title: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-bundle-item] .content .sub-header"),
                item: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-bundle-item]"),
                compareatprice: document.querySelector(".main-getting-started .step-4-container .review-container .review-item[data-bundle-item] .content .header .compare-at-price"),
            }
        }
        this.steps = {
            step1: document.querySelector('.main-getting-started .header-steps .step[data-step="1"] .title'),
            step2: document.querySelector('.main-getting-started .header-steps .step[data-step="2"] .title'),
            step3: document.querySelector('.main-getting-started .header-steps .step[data-step="3"] .title'),
            step4: document.querySelector('.main-getting-started .header-steps .step[data-step="4"] .title')
        }
        this.load();
    }

    GettingStarted.prototype.load = function() {

        var _ = this;

        // Van Movement and Progress Animation
        function updateVanPosition(stepNumber) {
            const vanContainer = document.querySelector('.van-container');
            const progressLines = document.querySelectorAll('.progress-line');
            
            if (!vanContainer) return;
            
            const currentStep = document.querySelector(`.header-steps .step[data-step="${stepNumber}"]`);
            if (!currentStep) return;
            
            const stepRect = currentStep.getBoundingClientRect();
            const containerRect = document.querySelector('.header-steps').getBoundingClientRect();
            const vanPosition = stepRect.left - containerRect.left + (stepRect.width / 2) - 30;
            
            vanContainer.style.left = vanPosition + 'px';
            
            // Update progress lines
            progressLines.forEach((line, index) => {
                if (index < stepNumber - 1) {
                    line.style.width = '100%';
                } else if (index === stepNumber - 1) {
                    line.style.width = '50%';
                } else {
                    line.style.width = '0%';
                }
            });
        }

        function updateStepStates(currentStepNumber) {
            const steps = document.querySelectorAll('.header-steps .step');
            steps.forEach((step, index) => {
                const stepNum = index + 1;
                step.classList.remove('active', 'completed', 'clickable');
                
                if (stepNum < currentStepNumber) {
                    step.classList.add('completed', 'clickable');
                } else if (stepNum === currentStepNumber) {
                    step.classList.add('active');
                }
            });
        }

        function goToStep(stepNumber, isBackButton = false) {
            const currentStep = parseInt(_.selector.main.dataset.step);
            
            // Only prevent forward navigation, allow backward navigation
            if (!isBackButton && stepNumber >= currentStep) return;
            
            _.selector.main.dataset.step = stepNumber;
            updateVanPosition(stepNumber);
            updateStepStates(stepNumber);
            
            // Reset state based on which step we're going back to
            if (stepNumber < 4) {
                // Going back from review step
                _.selector.addtocart.classList.remove("active");
            }
            if (stepNumber < 3) {
                // Going back from bundles step - reset bundle selections
                _.selector.selectbundle.forEach(el => {
                    el.checked = false;
                });
                _.state.bundleItems = [];
                const cancelBtn = document.querySelector('.step-3-container .cancel');
                if (cancelBtn) cancelBtn.innerText = 'No Thanks';
                _.state.addbundle = false;
            }
            if (stepNumber < 2) {
                // Disable continue button when going back to step 1
                if (_.selector.continueplan) {
                    _.selector.continueplan.classList.remove('active');
                    _.selector.continueplan.disabled = true;
                    _.selector.continueplan.title = "Select a plan to continue";
                }
                
                _.selector.selectplan.forEach(el => {
                    const planItem = el.closest('.selling-plan-item');
                    if (planItem) {
                        planItem.classList.remove('active', 'is-selected');
                        planItem.setAttribute('aria-selected', 'false');
                        const radio = planItem.querySelector('input[type="radio"]');
                        if (radio) radio.checked = false;
                    }
                });

                const selectedTotal = document.getElementById('selected-plan-total');
                if (selectedTotal) selectedTotal.classList.remove('has-selection');
                _.state.mainitem = {
                    "id": null, 
                    "selling_plan": null, 
                    "bgcolor": null, 
                    "discount": null, 
                    "freebox": false, 
                    "freeshipping": false, 
                    "promo": false,
                    "promocode": null,
                    "showsave": false,
                    "label": null,
                    "price": 0
                };
            }
        }

        // Initialize van position
        setTimeout(() => {
            const initialStep = parseInt(_.selector.main.getAttribute('data-step')) || 1;
            updateVanPosition(initialStep);
            updateStepStates(initialStep);
            toggleShopifySections(initialStep);
        }, 100);

        // Observe step changes
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'data-step') {
                    const currentStep = parseInt(_.selector.main.getAttribute('data-step'));
                    updateVanPosition(currentStep);
                    updateStepStates(currentStep);
                    toggleShopifySections(currentStep);
                }
            });
        });

        observer.observe(_.selector.main, { attributes: true });

        // Update on window resize
        window.addEventListener('resize', function() {
            const currentStep = parseInt(_.selector.main.getAttribute('data-step'));
            updateVanPosition(currentStep);
        });

        // REVERTED LOGIC FOR PERSONALIZED BOARD PRODUCT
        let personalizedBoardProduct = document.querySelector('[data-board-product]') 

        if(personalizedBoardProduct){
            let nameDisplay = personalizedBoardProduct.querySelector('.name-display') 
            if(nameDisplay){

                // Restored HTML with both firstname and lastname inputs
                nameDisplay.innerHTML = `
                    <div class="flex-review-input-free" >
                        <input class="review-input-free" data-attrib="firstname" type="text"  name="firstnameReview-free" placeholder="First Name">
                        <input class="review-input-free" data-attrib="lastname" type="text"  name="lastnameReview-free" placeholder="Last Name">
                    </div>
                `

                Array.from(document.querySelectorAll('.review-input-free')).forEach(freeInput => {
                    freeInput.addEventListener('input', event => {
                        _.state[event.target.getAttribute('data-attrib')] = event.target.value
                    })
                })

            }
        }


        if(_.selector.form) {   
            
            const firstnameInput = _.selector.form.querySelector('input[name="firstname"]');
            const submitButton = _.selector.form.querySelector('button[type="submit"]'); 

            function validateInputs() {
                let firstname = firstnameInput.value.trim();
                
                if (firstname !== "") {
                    submitButton.classList.add('active');
                } else {
                    submitButton.classList.remove('active');
                }

                _.state.firstname = firstname;

                if (_.selector.text_generated.length) {
                    _.selector.text_generated.forEach(el => {
                        el.textContent = `${_.state.firstname}`;
                        if (_.state.firstname !== '') {
                            el.closest('.text-render').classList.add('active')
                        }                           
                    });
                    _.steps.step1.textContent = `For: ${_.state.firstname}`;
                }
            }

            firstnameInput.addEventListener("input", validateInputs);

            validateInputs();

            _.selector.form.addEventListener("submit", event => {
                event.preventDefault();
                if(parseInt(_.selector.main.dataset.step) == 1) {
                    _.selector.main.dataset.step = 2; // Go to plan selection
                    _.state.firstname = event.target.firstname.value;
                    if(_.selector.text_generated.length) {
                        _.selector.text_generated.forEach(el => {
                            el.textContent = `${_.state.firstname}`;                            
                        })
                    }
                    _.steps.step1.textContent = `For: ${_.state.firstname}`;
                    return;
                }
            })
        }
        if(_.selector.steps.length > 0) {
            _.selector.steps.forEach(step => {
                step.addEventListener("click", event => {
                    const clickedStep = parseInt(event.target.closest(".step").dataset.step);
                    const currentStep = parseInt(_.selector.main.dataset.step);
                    
                    // Only allow clicking on completed steps (going back)
                    if (clickedStep < currentStep) {
                        goToStep(clickedStep);
                    }
                })
            })
        }

        // One-click plan selection. The radio input is the single source of truth.
        function selectPlan(planItem) {
            if (!planItem) return;

            const radioInput = planItem.querySelector('input[type="radio"]');
            if (!radioInput) return;

            radioInput.checked = true;

            const selectedTotal = document.getElementById('selected-plan-total');
            if (selectedTotal) selectedTotal.classList.add('has-selection');

            _.state.mainitem.id = parseInt(planItem.dataset.variantId, 10);
            _.state.mainitem.selling_plan = parseInt(planItem.dataset.sellingPlan, 10);
            _.state.mainitem.bgcolor = planItem.dataset.bgcolor;
            _.state.mainitem.discount = planItem.dataset.discount;
            _.state.mainitem.freebox = planItem.dataset.freebox === "true";
            _.state.mainitem.freeshipping = planItem.dataset.freeshipping === "true";
            _.state.mainitem.price = planItem.dataset.price;
            _.state.mainitem.promo = planItem.dataset.promo === "true";
            _.state.mainitem.promocode = planItem.dataset.promoCode;
            _.state.mainitem.promotitle = planItem.dataset.promoTitle;
            _.state.mainitem.showsave = planItem.dataset.showSave === "true";
            _.state.mainitem.label = planItem.dataset.label;
            _.state.mainitem.isPrepaid =
                String(planItem.dataset.label || '').indexOf('Prepaid-') === 0;

            document.querySelectorAll('.step-2-container .selling-plan-item')
                .forEach(item => {
                    const itemInput = item.querySelector('input[type="radio"]');
                    const selected = itemInput === radioInput;
                    item.classList.toggle('active', selected);
                    item.classList.toggle('is-selected', selected);
                    item.setAttribute('aria-selected', String(selected));
                });

            if (_.selector.continueplan) {
                _.selector.continueplan.classList.add('active');
                _.selector.continueplan.disabled = false;
                _.selector.continueplan.textContent = 'Continue';
                _.selector.continueplan.title = 'Continue with ' + (planItem.dataset.label || 'this plan');
            }

            _.steps.step2.textContent = planItem.dataset.label || 'Plan';

            const dataMainItemLabel = document.querySelector(
                '.step-4-container [data-main-item] .header'
            );

            if (dataMainItemLabel) {
                const existingLabel = dataMainItemLabel.querySelector('.month-label');
                if (existingLabel) existingLabel.remove();
                dataMainItemLabel.insertAdjacentHTML(
                    'afterbegin',
                    `<span class="month-label">${planItem.dataset.label || ''}</span>`
                );
            }

            radioInput.dispatchEvent(new Event('change', { bubbles: true }));
            _.steps.step2.classList.remove("peculiar");
        }

        const planList = document.querySelector('.step-2-container .selling-plan-container');

        if (planList) {
            planList.addEventListener('click', event => {
                const planItem = event.target.closest('.selling-plan-item');
                if (!planItem || !planList.contains(planItem)) return;
                event.preventDefault();
                selectPlan(planItem);
            });
        }

        // No plan is selected by default. The customer must actively choose one.

        // Continue button click handler for step 2
        if(_.selector.continueplan) {
            _.selector.continueplan.addEventListener("click", () => {
                if(_.selector.continueplan.classList.contains('active')) {

                    // Hide/Show Step 3 bundle items based on limited time offer status
                    document.querySelectorAll("[data-limited-time-offer]").forEach(el => el.style.display = 'none');
                    document.querySelectorAll("[data-limited-time-offer-bundle-item]").forEach(el => el.style.display = 'none');
                    document.querySelectorAll(".bundle-item:not([data-limited-time-offer-bundle-item])").forEach(el => el.style.display = 'block');

                    if (_.state.mainitem.isPrepaid && _.state.limited_time_offer) {
                        document.querySelectorAll(".bundle-item").forEach(el => {
                            el.hasAttribute("data-limited-time-offer-bundle-item") ? el.style.display = "block" : el.style.display = "none";
                        });
                        
                        if (_.state.mainitem.label === "Prepaid-12 Months") {
                            document.querySelectorAll("[data-limited-time-offer-twelve]").forEach(el => el.style.display = 'flex');

                            Array.from(document.querySelectorAll('[data-bundle-count="4"], [data-bundle-count="1"]'))
                                .forEach(bundle => bundle.style.display = "none");

                        } else if (_.state.mainitem.label === "Prepaid-6 Months") {
                            document.querySelectorAll("[data-limited-time-offer-six]").forEach(el => el.style.display = 'flex');

                            Array.from(document.querySelectorAll('[data-bundle-count="4"]'))
                                .forEach(bundle => bundle.style.display = "none");
                            Array.from(document.querySelectorAll('[data-bundle-count="1"]'))
                                .forEach(bundle => bundle.style.display = "block");
                        }

                    } else {
                        document.querySelectorAll(".bundle-item").forEach(el => {
                            el.hasAttribute("data-limited-time-offer-bundle-item") ? el.style.display = "none" : el.style.display = "block";
                        });
                        document.querySelectorAll("[data-limited-time-offer]").forEach(el => el.style.display = 'none');
                    }

                    Array.from(document.querySelectorAll('.review-input-free')).forEach(freeInput => {
                        freeInput.value = _.state[freeInput.getAttribute('data-attrib')]
                    })

                    // Explicitly prepare the correct Step 3 screen before showing it.
                    const step3Container = document.querySelector('.step-3-container');
                    const twelveMonthGiftStep = step3Container
                        ? step3Container.querySelector('.twelve-month-kit-step')
                        : null;
                    const standardBoostStep = step3Container
                        ? step3Container.querySelector('.standard-step-3-content')
                        : null;

                    if (_.state.mainitem.label === "Prepaid-12 Months") {
                        if (twelveMonthGiftStep) twelveMonthGiftStep.hidden = false;
                        if (standardBoostStep) standardBoostStep.hidden = true;
                        if (step3Container) {
                            step3Container.dataset.twelveMonthSubstep = 'gifts';
                        }
                    } else {
                        if (twelveMonthGiftStep) twelveMonthGiftStep.hidden = true;
                        if (standardBoostStep) standardBoostStep.hidden = false;
                        if (step3Container) {
                            step3Container.dataset.twelveMonthSubstep = 'standard';
                        }
                    }

                    // Start clearing the cart while the customer reviews bonuses/add-ons.
                    // Reusing this promise removes the extra pause before checkout.
                    _.cartPreparationPromise = fetch(
                        window.Shopify.routes.root + 'cart/clear.js',
                        { method: 'POST', headers: { 'Accept': 'application/json' } }
                    ).catch(() => null);

                    // Now go to step 3
                    _.selector.main.dataset.step = 3;
                }
            })
        }

        // 12-month free-kit and personalized-board controls.
        // This is handled in the main asset so it cannot be skipped by section timing.
        const twelveMonthGiftStep = document.querySelector('.twelve-month-kit-step');

        if (twelveMonthGiftStep) {
            const freeKitChoices = Array.from(
                twelveMonthGiftStep.querySelectorAll('[data-free-kit-choice]')
            );
            const freeKitContinue = twelveMonthGiftStep.querySelector(
                '.twelve-month-kit-continue'
            );
            const freeKitSummary = twelveMonthGiftStep.querySelector(
                '[data-free-kit-summary]'
            );
            const freeKitConfirmation = twelveMonthGiftStep.querySelector(
                '[data-free-kit-confirmation]'
            );
            const freeKitConfirmationText = twelveMonthGiftStep.querySelector(
                '[data-free-kit-confirmation-text]'
            );
            const boardChoice = twelveMonthGiftStep.querySelector(
                '[data-board-choice]'
            );
            const boardFields = twelveMonthGiftStep.querySelector(
                '[data-board-name-fields]'
            );
            const boardFirstName = twelveMonthGiftStep.querySelector(
                '[data-board-first-name]'
            );
            const boardLastName = twelveMonthGiftStep.querySelector(
                '[data-board-last-name]'
            );
            const boardError = twelveMonthGiftStep.querySelector(
                '[data-board-name-error]'
            );

            function cleanFreeKitTitle(input) {
                return String(input?.dataset.title || 'Free kit')
                    .replace(/^FREE\s+/i, '');
            }

            function syncFreeKitControls() {
                const selectedKit = freeKitChoices.find(input => input.checked);

                if (freeKitSummary) {
                    freeKitSummary.textContent = selectedKit
                        ? cleanFreeKitTitle(selectedKit)
                        : 'Choose one above';
                }

                if (freeKitConfirmation) {
                    freeKitConfirmation.hidden = !selectedKit;
                }

                if (freeKitConfirmationText) {
                    freeKitConfirmationText.textContent = selectedKit
                        ? `FREE KIT ADDED: ${cleanFreeKitTitle(selectedKit)}`
                        : '';
                }

                if (freeKitContinue) {
                    freeKitContinue.disabled = !selectedKit;
                    freeKitContinue.textContent = selectedKit
                        ? 'Continue to Boost their learning'
                        : 'Choose your free kit';
                }
            }

            function syncBoardFields() {
                const selected = Boolean(boardChoice?.checked);

                if (boardFields) boardFields.hidden = !selected;

                if (boardFirstName) {
                    boardFirstName.required = selected;
                    boardFirstName.setAttribute(
                        'aria-required',
                        selected ? 'true' : 'false'
                    );

                    if (selected && !boardFirstName.value.trim()) {
                        boardFirstName.value = _.state.firstname || '';
                    }
                }

                if (boardLastName && selected && !boardLastName.value.trim()) {
                    boardLastName.value = _.state.lastname || '';
                }

                if (!selected && boardError) boardError.hidden = true;
            }

            freeKitChoices.forEach(input => {
                input.addEventListener('change', () => {
                    freeKitChoices.forEach(other => {
                        if (other !== input) other.checked = false;
                    });
                    syncFreeKitControls();
                });
            });

            if (boardChoice) {
                boardChoice.addEventListener('change', syncBoardFields);
            }

            if (boardFirstName) {
                boardFirstName.addEventListener('input', event => {
                    _.state.firstname = event.target.value;
                    if (boardError) boardError.hidden = true;
                });
            }

            if (boardLastName) {
                boardLastName.addEventListener('input', event => {
                    _.state.lastname = event.target.value;
                });
            }

            if (freeKitContinue) {
                freeKitContinue.addEventListener('click', event => {
                    event.preventDefault();
                    event.stopPropagation();

                    const selectedKit = freeKitChoices.find(
                        input => input.checked
                    );

                    if (!selectedKit) {
                        twelveMonthGiftStep
                            .querySelector('.free-kit-grid')
                            ?.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        syncFreeKitControls();
                        return;
                    }

                    if (
                        boardChoice?.checked &&
                        !boardFirstName?.value.trim()
                    ) {
                        if (boardError) boardError.hidden = false;
                        boardFields?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                        boardFirstName?.focus();
                        return;
                    }

                    const step3Container =
                        document.querySelector('.step-3-container');
                    const standardBoostStep =
                        step3Container?.querySelector(
                            '.standard-step-3-content'
                        );

                    twelveMonthGiftStep.hidden = true;
                    if (standardBoostStep) standardBoostStep.hidden = false;

                    if (step3Container) {
                        step3Container.dataset.twelveMonthSubstep = 'boost';
                        window.setTimeout(() => {
                            window.scrollTo({
                                top: step3Container.offsetTop - 20,
                                behavior: 'smooth'
                            });
                        }, 40);
                    }
                });
            }

            syncFreeKitControls();
            syncBoardFields();
        }

        // Back button handlers
        if (_.selector.backButtons.length > 0) {
            _.selector.backButtons.forEach(button => {
                button.addEventListener('click', function() {
                    const currentStep = parseInt(_.selector.main.getAttribute('data-step'));
                    const targetStep = currentStep - 1; // Go to previous step based on current step
                    
                    if (targetStep >= 1) {
                        goToStep(targetStep, true); // Pass true to indicate it's a back button click
                    }
                });
            });
        }      
        if(_.selector.selectbundle.length > 0) {
            _.selector.selectbundle.forEach(bundle => {
                bundle.addEventListener("change", event => {
                    console.log("TEST arjun:: bundle clicked", event.target.closest('.bundle-item').dataset.bundleCount);


                    if(event.target.checked) {

                        _.state.bundleitem.id = parseInt(event.target.dataset.variantId);
                        _.state.bundleitem.selling_plan = parseInt(event.target.value);
                        _.state.bundleitem.bg_image = event.target.dataset.bgimage;
                        _.state.bundleitem.price = event.target.dataset.price;
                        _.state.bundleitem.title = event.target.dataset.title;
                        _.state.bundleitem.bundleCount = event.target.closest('.bundle-item').dataset.bundleCount
                        _.state.bundleitem.active = true

                        console.log("TEST:: -- bundle item id", event.target.dataset.variantId);
                        if (event.target.dataset.variantId == 44655856419015) {
                            document.querySelectorAll("[data-bundle-item] [data-addon-input]").forEach(el => {
                                el.style.setProperty("display", "block");
                            })
                            document.querySelector("[data-bundle-item] [data-addon-input][name='firstnameReview']").value = _.state.firstname;
                            document.querySelector("[data-bundle-item] [data-addon-input][name='lastnameReview']").value = _.state.lastname; // Populate Last Name
                        } else {
                            document.querySelectorAll("[data-bundle-item] [data-addon-input]").forEach(el => {
                                el.style.setProperty("display", "none");
                            })
                        }
                        _.state.bundleitem.compate_at_price = event.target.dataset.comparePrice;
                        // _.selector.main.dataset.step = 5;
                        _.state.addbundle = true;
                        if(event.target.closest('.bundle-item').dataset.bundleCount === '2') {
                            _.selector.finalsecondproduct.classList.add('active');
                        } else {
                            _.selector.finalsecondproduct.classList.remove('active');
                        }
                        if(event.target.closest('.bundle-item').dataset.bundleCount === '5') {
                            _.selector.finalfifthproduct.classList.add('active');
                        } else {
                            _.selector.finalfifthproduct.classList.remove('active');
                        }

                         _.reviewsummary();

                        console.log("arjun bundle item", _.state.bundleitem) 

                         _.state.bundleItems = [
                            ..._.state.bundleItems,  
                            {..._.state.bundleitem}
                        ]

                    }else{
                        // alert(1)

                        if(
                            (
                                _.state.bundleItems
                                .map( bundleItem => bundleItem.id )
                                .includes(parseInt(event.target.dataset.variantId))
                            )
                        ){
                            
                            // only if it exists
                            _.state.bundleItems = 
                            _.state.bundleItems.filter(item => item.id !== parseInt(event.target.dataset.variantId))

                        } 

                    }

                    console.log("arjun bundleitems")
                    console.log(_.state.bundleItems)

                    document.querySelector('.step-3-container .cancel').innerText = 
                    _.state.bundleItems.length ? 'Continue' : 'No Thanks'


                })
            })
        }

        if (_.selector.cancelbundle) {
            _.selector.cancelbundle.addEventListener("click", async () => {
                if (_.selector.cancelbundle.disabled) return;

                if (_.state.bundleItems.length === 0) {
                    _.state.bundleitem.id = null;
                    _.state.bundleitem.selling_plan = null;
                    _.state.addbundle = false;
                }

                _.state.bundleItems = _.state.bundleItems.filter(item => item.active);

                if (!document.querySelector('.tft-checkout-loading')) {
                    const overlay = document.createElement('div');
                    overlay.className = 'tft-checkout-loading';
                    overlay.innerHTML = `
                        <div class="tft-checkout-loading__card">
                            <div class="tft-checkout-loading__spinner" aria-hidden="true"></div>
                            <strong>Preparing your secure checkout</strong>
                            <span>This should only take a moment…</span>
                        </div>
                    `;
                    document.body.appendChild(overlay);
                }

                _.selector.cancelbundle.disabled = true;

                await _.addtocart(
                    _.state.addbundle,
                    _.state.mainitem.isPrepaid,
                    _.state.limited_time_offer
                );

                _.selector.cancelbundle.disabled = false;
            });
        }



        if(_.selector.addtocart) {
            _.selector.addtocart.addEventListener("click", () => {
                if(_.state.bundleitem.id) {
                    _.addtocart(_.state.addbundle, _.state.mainitem.isPrepaid, _.state.limited_time_offer);
                } else {
                    _.addtocart(_.state.addbundle, _.state.mainitem.isPrepaid, _.state.limited_time_offer);
                }
            })
        }
        if(_.selector.reviewitems.length > 0) {
            _.selector.reviewitems.forEach(el => {
                el.addEventListener("change", event => {
                    if(event.target.checked) {
                        _.state.addbundle = true;
                    } else {
                        _.state.addbundle = false;
                    }
                    _.selector.addtocart.classList.remove("active");
                })
            })
        }
        if(_.selector.finalsecondproduct) {
            _.selector.finalsecondproduct.addEventListener('click', event => {
                _.state.bundleitem.id = parseInt(event.target.dataset.variantId);
                _.state.bundleitem.selling_plan = parseInt(event.target.value);
                _.state.bundleitem.bg_image = event.target.dataset.bgimage;
                _.state.bundleitem.price = event.target.dataset.price;
                _.state.bundleitem.title = event.target.dataset.title;
                _.state.bundleitem.compate_at_price = event.target.dataset.comparePrice;
                _.review.bundleitem.checkbox.style.backgroundImage = `url(${_.state.bundleitem.bg_image})`;
                _.review.bundleitem.price.textContent = _.state.bundleitem.price;
                _.review.bundleitem.title.textContent = _.state.bundleitem.title;
            })
        }
        if(_.selector.finalfifthproduct) {
            _.selector.finalfifthproduct.addEventListener('click', event => {
                _.state.bundleitem.id = parseInt(event.target.dataset.variantId);
                _.state.bundleitem.selling_plan = parseInt(event.target.value);
                _.state.bundleitem.bg_image = event.target.dataset.bgimage;
                _.state.bundleitem.price = event.target.dataset.price;
                _.state.bundleitem.title = event.target.dataset.title;
                _.state.bundleitem.compate_at_price = event.target.dataset.comparePrice;
                _.review.bundleitem.checkbox.style.backgroundImage = `url(${_.state.bundleitem.bg_image})`;
                _.review.bundleitem.price.textContent = _.state.bundleitem.price;
                _.review.bundleitem.title.textContent = _.state.bundleitem.title;
            })
        }
        if(_.selector.reviewInputs.length > 0) {
            Array.from(_.selector.reviewInputs).find(el => el.name === "firstnameReview")?.addEventListener("input", event => {
                _.state.firstname = event.target.value;
            });
            // ADDED BACK: Last name input listener
            Array.from(_.selector.reviewInputs).find(el => el.name === "lastnameReview")?.addEventListener("input", event => {
                _.state.lastname = event.target.value;
            });
        }
        console.log("TEST:: review inputs", _.selector.reviewInputs);
        if(_.selector.reviewInputs.length > 0) {
            console.log("TEST:: A");
            _.selector.reviewInputs.forEach(el => {
                el.addEventListener("input", event => {
                    console.log("TEST:: review input", event.target.value);
                })
            })
        }
    }

    GettingStarted.prototype.generateBundleSummary = function(){


        let normalBundleItem  = document.querySelector('[data-bundle-item]:not([data-limited-time-offer])');
        
        normalBundleItem.style.display = "none" 

        if(document.querySelector('.new-bundle-items-container')){
            document.querySelector('.new-bundle-items-container').remove() 
        }   
        
        const newBundleItemsContainer = document.createElement('div')
        newBundleItemsContainer.className = "new-bundle-items-container"
        var _ = this 

        newBundleItemsContainer.innerHTML = this.state.bundleItems.map(function(item, index) {
            // Optimize the background image URL
            let optimizedBgImage = item.bg_image;
            if (optimizedBgImage) {
                // Add width parameter if not already present
                if (!optimizedBgImage.includes('width=')) {
                    const separator = optimizedBgImage.includes('?') ? '&' : '?';
                    optimizedBgImage = optimizedBgImage + separator + 'width=300';
                }
            }
            
            return`
                <div class="review-item review-item-custom" data-bundle-item="" style="display: flex;">
                    <div class="checkbox" 
                        style="background-image: url('${optimizedBgImage}'); background-size: cover; background-position: center;">   
                        <input ${item.active == true ? 'checked': "" } class="bundle-item-checkbox" data-id="${item.id}" type="checkbox" id="review_bundle_item_${index}" name="review_item_${index}">                   
                        <label for="review_bundle_item_${index}"></label> 
                    </div>
                    <div class="content">                                                
                        <span class="header">
                            <span class="sub-header">${item.title}</span>
                            <span class="title">${item.price}</span>
                            ${
                                item.compate_at_price.length > 0
                                ? `<span class="compare-at-price">${item.compate_at_price}</span>`
                                : ''
                            }
                        </span>
                        ${
                            item.bundleCount == 2
                            ? `
                                <div class="second-product-variants active">
                                    ${
                                        _.selector.finalsecondproduct.innerHTML
                                        .replaceAll(' id="', ' id="new-')
                                        .replaceAll('for="', 'for="new-')
                                        .replaceAll('name="final_bundle_item_boost"', 'name="final_second_bundle_item_boost"')
                                    }
                                </div>
                            `
                            : ''
                        }
                        ${
                            item.bundleCount == 5
                            ? `
                                <div class="fifth-product-variants active">
                                    ${
                                        _.selector.finalfifthproduct.innerHTML
                                        .replaceAll(' id="', ' id="new-')
                                        .replaceAll('for="', 'for="new-')
                                    }
                                </div>
                            `
                            : ''
                        }
                        ${
                            item.id == "44655856419015"
                                ? `
                                    <div class="flex-review-input">
                                        <input class="review-input" data-attrib="firstname" type="text" value="${_.state.firstname}" name="firstnameReview" placeholder="First Name" data-addon-input="">
                                        <input style="margin-top:5px" class="review-input" data-attrib="lastname" type="text" value="${_.state.lastname}" name="lastnameReview" placeholder="Last Name" data-addon-input="">
                                    </div>
                                `
                                : ''
                        }
                    </div>                                           
                </div>
            `
        })
        .join('')



        document.querySelector('.review-container').appendChild(newBundleItemsContainer)
        Array.from(document.querySelectorAll('.review-item-custom .review-input')).forEach(a => {
            a.addEventListener('input' , event => {
                console.log("hello")
                _.state[event.target.getAttribute('data-attrib')] = event.target.value
            })
        })
        Array.from(document.querySelectorAll('.bundle-item-checkbox')).forEach(input => {
            input.addEventListener('change', event => {

                const inputelm = event.target 

                for (const item of _.state.bundleItems) {
                    // use item directly
                    if(item.id == parseInt(inputelm.getAttribute('data-id'))){
                        item.active = inputelm.checked 
                    }
                }   
                console.log("in summary", _.state.bundleItems)             

            })
        })

        
        const itemWithBundleCOunt2or5 =    _.state.bundleItems
            .filter(item =>parseInt(item.bundleCount) == 2 || parseInt(item.bundleCount) == 5 )
        
            
        
        document.querySelectorAll("input[name='final_second_bundle_item_boost'], input[name='final_bundle_item_boost']")
        .forEach(fintalItemBoost => {
            fintalItemBoost.removeAttribute('checked') 

            if(itemWithBundleCOunt2or5.length){
                itemWithBundleCOunt2or5.forEach(item => {
                    if(item.id == parseInt(fintalItemBoost.getAttribute('data-variant-id'))){
                        fintalItemBoost.setAttribute('checked', true) 
                    }
                })
            }

            
            fintalItemBoost.addEventListener('change',function(event){

                if(event.target.checked){

                    let bundleCountThisInputRelatesTo = 
                    event.target.getAttribute('name') == "final_second_bundle_item_boost" ? 2 :5

                    _.state.bundleItems = _.state.bundleItems.map(item => {
                        if (parseInt(item.bundleCount) == bundleCountThisInputRelatesTo) {
                            return {
                                "id": parseInt(event.target.getAttribute('data-variant-id')),
                                "selling_plan": event.target.value,
                                active:true,
                                "bg_image": event.target.getAttribute('data-bgimage'),
                                "price": event.target.getAttribute('data-price'),
                                "title": event.target.getAttribute('data-title'),
                                "compate_at_price": event.target.getAttribute('data-compare-price'),
                                "bundleCount": bundleCountThisInputRelatesTo
                            };
                        }
                        return item; // Return the unmodified item if condition is not met
                    });

                    _.generateBundleSummary() 
                }
            })
        })

    }
    
GettingStarted.prototype.reviewsummary = function() {

    var _ = this;
    console.log("TEST:: Review Main Item:", _.state.mainitem); // Debugging line
    _.review.mainitem.checkbox.style.setProperty("background-color", _.state.mainitem.bgcolor);
    _.review.mainitem.label.textContent = _.state.mainitem.label;
    console.log("TEST:: Setting review main item price to:", _.state.mainitem.price); // Added log
    _.review.mainitem.price.textContent = _.state.mainitem.price;
    _.state.mainitem.freeshipping ? _.review.mainitem.freeshipping.style.setProperty("display", "block") : _.review.mainitem.freeshipping.style.setProperty("display", "none");
    _.state.mainitem.freebox ? _.review.mainitem.freebox.style.setProperty("display", "block") : _.review.mainitem.freebox.style.setProperty("display", "none");
    _.state.mainitem.freebox && _.review.mainitem.freebox.style.setProperty("color", _.state.mainitem.bgcolor);
    _.state.mainitem.promo ? _.review.mainitem.promo.style.setProperty("display", "block") : _.review.mainitem.promo.style.setProperty("display", "none");
    _.review.mainitem.promocode.textContent = _.state.mainitem.promocode;
    _.review.mainitem.promotitle.textContent = _.state.mainitem.promotitle;
    _.state.mainitem.showsave ? _.review.mainitem.saved.style.setProperty("display", "block") : _.review.mainitem.saved.style.setProperty("display", "none");
    _.review.mainitem.saved.style.setProperty("background-color", _.state.mainitem.bgcolor);
    _.review.mainitem.savedamount.textContent = _.state.mainitem.discount;
    
// Update monthly bonus summary only
const bonusSummary = document.querySelector("[data-board-product]");

if (bonusSummary) {
    const title = bonusSummary.querySelector(".sub-header");
    const nameDisplay = bonusSummary.querySelector(".name-display");
    const checkbox = bonusSummary.querySelector(".checkbox");

    const isMonthly6Summary = !_.state.mainitem.isPrepaid &&
        _.state.mainitem.label === "Monthly-6 Months";

    const isMonthly12Summary = !_.state.mainitem.isPrepaid &&
        _.state.mainitem.label === "Monthly-12 Months";

    if (isMonthly6Summary) {
        if (title) title.textContent = "Alphabet Dry Erase Book";
        if (nameDisplay) nameDisplay.style.display = "none";
        if (checkbox) {
            checkbox.innerHTML = "";
            checkbox.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0540/0808/6727/files/Untitleddesign_20.png?v=1782241928)";
            checkbox.style.backgroundSize = "contain";
            checkbox.style.backgroundRepeat = "no-repeat";
            checkbox.style.backgroundPosition = "center";
        }
    }

    if (isMonthly12Summary) {
        if (title) title.textContent = "Mystery Kit";
        if (nameDisplay) nameDisplay.style.display = "none";
        if (checkbox) {
            checkbox.innerHTML = "";
            checkbox.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0540/0808/6727/files/1_0587b25c-5b1c-468d-aae7-b3272fd3c6a7.png?v=1769030530)";
            checkbox.style.backgroundSize = "contain";
            checkbox.style.backgroundRepeat = "no-repeat";
            checkbox.style.backgroundPosition = "center";
        }
    }
}


    _.review.bundleitem.checkbox.style.backgroundImage = `url(${_.state.bundleitem.bg_image})`;
    _.review.bundleitem.price.textContent = _.state.bundleitem.price;
    _.review.bundleitem.title.textContent = _.state.bundleitem.title;
    _.review.bundleitem.input.checked = _.state.addbundle;
    _.state.addbundle ? _.review.bundleitem.item.style.setProperty("display", "flex") : _.review.bundleitem.item.style.setProperty("display", "none");
    _.state.bundleitem.compate_at_price.length > 0  && (_.review.bundleitem.compareatprice.textContent = _.state.bundleitem.compate_at_price);
    
    _.generateBundleSummary()



    // Update sub-title to say (prepaid) = x upfront if the plan is prepaid
    const subTitleElement = _.review.mainitem.price.closest('.header').querySelector('.sub-title');
    
    if(subTitleElement){
        if (_.state.mainitem.isPrepaid) {
            const monthsText = _.review.mainitem.label.textContent.match(/\d+/)[0];
            const months = parseInt(monthsText);
            const monthlyPrice = parseInt(_.review.mainitem.price.textContent.replace('$', ''));
            const upfrontAmount = months * monthlyPrice;
            subTitleElement.textContent = `month (prepaid) = $${upfrontAmount} upfront`;
            

        } else {
            subTitleElement.textContent = `month`;


        }
        _.review.mainitem.label.textContent = ''
    }else{
        console.error("sub title not found to display it is prepaid")
    }

    // --- Update review for FREE bonus items ---
    // The visibility is handled in the plan selection listener now.
    // You might want to add logic here if the content of the free items needs dynamic updates (e.g., personalized name on the board review item).
    const freeBoardReviewNameInput = _.selector.reviewFreeBoard?.querySelector('.review-input[data-attrib="firstname"]');
    const freeBoardReviewLastNameInput = _.selector.reviewFreeBoard?.querySelector('.review-input[data-attrib="lastname"]');
    
    if (freeBoardReviewNameInput) freeBoardReviewNameInput.value = _.state.firstname;
    if (freeBoardReviewLastNameInput) freeBoardReviewLastNameInput.value = _.state.lastname;
}

    
    GettingStarted.prototype.addtocart = async function(withbundle, isPrepaid, limitedTimeOffer) {
        // Add loading state to button


        var _ = this; 

        _.state.bundleItems = _.state.bundleItems.filter(item => item.active)

        _.selector.addtocart.classList.add("active", "loading");
        _.selector.addtocart.disabled = true;

        // Create and add spinner element
        const spinner = document.createElement('div');
        spinner.classList.add('loading-spinner');
        spinner.innerHTML = `<div class="spinner"></div>`;
        _.selector.addtocart.appendChild(spinner);

        // Add CSS if not already present
        if (!document.querySelector('style[data-spinner-style]')) {
            const style = document.createElement('style');
            style.setAttribute('data-spinner-style', '');
            style.textContent = `
                .loading-spinner {
                    display: none;
                    margin-left: 8px;
                }
                .loading .loading-spinner {
                    display: inline-block;
                }
                .spinner {
                    width: 12px;
                    height: 12px;
                    border: 3px solid rgba(255,255,255,0.3);
                    border-radius: 50%;
                    border-top-color: black;
                    animation: spin 1s ease-in-out infinite;
                }
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
                .add-to-cart {
                    transition: width 0.3s ease-in-out;
                }
                .add-to-cart.loading {
                    width: 140px;
                }
            `;
            document.head.appendChild(style);
        }
        var _ = this;
        let formData = {
            'items': [],
            sections: `cart-count,${_.selector.cartdrawer.dataset.sectionId}`,
            attributes: {
                'Child First Name': _.state.firstname,
                'Child Last Name': _.state.lastname // Include Last Name in attributes
            }
        }

// Add the currently selected Boost Their Learning products for every plan.
// Read directly from the live Boost cards so the cart always matches the UI.
document
    .querySelectorAll('.standard-step-3-content [data-boost-choice]:checked')
    .forEach(input => {
        const variantId = parseInt(input.dataset.variantId, 10);

        if (!variantId) return;

        const cartItem = {
            id: variantId,
            quantity: 1
        };

        // Preserve personalization for any paid personalized-board add-on.
        if (
            input.matches('[data-three-month-name-board] [data-boost-choice]') ||
            input.closest('[data-three-month-name-board]')
        ) {
            const fullName = [_.state.firstname, _.state.lastname]
                .filter(Boolean)
                .join(' ')
                .trim();

            if (fullName) {
                cartItem.properties = { Name: fullName };
            }
        }

        formData.items.push(cartItem);
    });

        // Determine base item and potential free items
        let baseItem = {
            'id': _.state.mainitem.id,
            'quantity': 1,
            'selling_plan': _.state.mainitem.selling_plan,
            'properties': {
                'First name': _.state.firstname,
                'Last name': _.state.lastname
            }
        };
        formData.items.push(baseItem);

        let discountCodes = [];

// Monthly 6 Month = Alphabet Book
const isMonthly6 = !isPrepaid &&
    _.state.mainitem.label === "Monthly-6 Months";

if (isMonthly6) {
   formData.items.push({
    id: 44806034227399,
    quantity: 1
});
discountCodes.push('MONTHLYALPHABETFREE');
const boardSummary = document.querySelector('[data-board-product]');
if (boardSummary) {
    boardSummary.querySelector('.sub-header').textContent = 'Alphabet Dry Erase Book';
    boardSummary.querySelector('.checkbox').style.backgroundImage = '';
    boardSummary.querySelector('.name-display').style.display = 'none';
}
}

// Monthly 12 Month = Mystery Kit
const isMonthly12 = !isPrepaid &&
    _.state.mainitem.label === "Monthly-12 Months";

if (isMonthly12) {
    formData.items.push({
        id: 46923769282759,
        quantity: 1
    });

    discountCodes.push('MONTHLYMYSTERYFREE');
}

        if (isPrepaid) {
            if (_.state.mainitem.label === "Prepaid-3 Months") {
                // The 3-month plan includes the hidden wooden cutter automatically.
                const cutterInput = document.querySelector('[data-three-month-free-cutter]');
                const cutterVariantId = cutterInput
                    ? parseInt(cutterInput.dataset.variantId, 10)
                    : null;

                if (cutterVariantId) {
                    formData.items.push({
                        id: cutterVariantId,
                        quantity: 1
                    });
                }
            }

            if (_.state.mainitem.label === "Prepaid-6 Months") {

                discountCodes.push('6MONTHPREPAIDPROMO');

                // Uses the product selected in the section's current
                // "Prepaid-6 months Bonus Settings" product picker.
                const sixMonthBonus = document.getElementById('six-months-bonus-item');
                const sixMonthVariantId = sixMonthBonus
                    ? parseInt(sixMonthBonus.dataset.variantId, 10)
                    : null;

                if (sixMonthVariantId) {
                    formData.items.push({
                        id: sixMonthVariantId,
                        quantity: 1,
                        properties: {
                            '6-month bonus': 'Dry-Erase Alphabet Book + Flash Cards — included FREE'
                        }
                    });
                }
            }

            if (_.state.mainitem.label === "Prepaid-12 Months") {

                discountCodes.push('12MONTHPREPAIDPROMO');

                const twelveMonthAlphabetBundle =
                    document.getElementById('six-months-bonus-item');
                const twelveMonthAlphabetBundleId =
                    twelveMonthAlphabetBundle
                        ? parseInt(
                            twelveMonthAlphabetBundle.dataset.variantId,
                            10
                        )
                        : null;

                if (twelveMonthAlphabetBundleId) {
                    formData.items.push({
                        id: twelveMonthAlphabetBundleId,
                        quantity: 1,
                        properties: {
                            '12-month bonus': 'Dry-Erase Alphabet Book + Flash Cards — included FREE'
                        }
                    });
                }

                // Add the exact free kit selected by the customer.
                const selectedFreeKit = document.querySelector(
                    '[data-free-kit-choice]:checked'
                );
                const selectedFreeKitId = selectedFreeKit
                    ? parseInt(selectedFreeKit.dataset.variantId, 10)
                    : null;

                if (selectedFreeKitId) {
                    formData.items.push({
                        id: selectedFreeKitId,
                        quantity: 1,
                        properties: {
                            'Bonus savings': '$58 value — included FREE with your 12-month plan'
                        }
                    });
                }

                // Always add the FREE Dry Erase Name Board with the 12-month plan.
                const boardFirstName = (
                    document.querySelector('[data-board-first-name]')?.value ||
                    _.state.firstname ||
                    ''
                ).trim();

                const boardLastName = (
                    document.querySelector('[data-board-last-name]')?.value ||
                    _.state.lastname ||
                    ''
                ).trim();

                formData.items.push({
                    id: 46857790390471,
                    quantity: 1,
                    properties: {
                        'First name': boardFirstName,
                        'Last name': boardLastName,
                        '12-month bonus': 'Dry Erase Name Board — included FREE'
                    }
                });
            }

        }


        // Final prepaid-bonus guarantee.
        // Use the selected selling-plan ID rather than labels or limited-offer state,
        // so these products are always present in the cart payload.
        function addUniqueCartItem(item) {
            const itemId = parseInt(item.id, 10);
            if (!itemId) return;

            const alreadyAdded = formData.items.some(existing => {
                return parseInt(existing.id, 10) === itemId;
            });

            if (!alreadyAdded) {
                formData.items.push({
                    ...item,
                    id: itemId,
                    quantity: item.quantity || 1
                });
            }
        }

        const selectedSellingPlanId = parseInt(
            _.state.mainitem.selling_plan,
            10
        );

        if (selectedSellingPlanId === 3049029831) {
            const alphabetBundleElement =
                document.getElementById('six-months-bonus-item');
            const alphabetBundleVariantId = alphabetBundleElement
                ? parseInt(alphabetBundleElement.dataset.variantId, 10)
                : null;

            addUniqueCartItem({
                id: alphabetBundleVariantId,
                properties: {
                    '6-month bonus': 'Dry-Erase Alphabet Book + Flash Cards — included FREE'
                }
            });
        }

        if (selectedSellingPlanId === 829915335) {
            const alphabetBundleElement =
                document.getElementById('six-months-bonus-item');
            const alphabetBundleVariantId = alphabetBundleElement
                ? parseInt(alphabetBundleElement.dataset.variantId, 10)
                : null;

            addUniqueCartItem({
                id: alphabetBundleVariantId,
                properties: {
                    '12-month bonus': 'Dry-Erase Alphabet Book + Flash Cards — included FREE'
                }
            });

        }

        // Keep a network problem from trapping the customer for a full minute.
        async function fetchWithTimeout(url, options, timeoutMs) {
            const controller = new AbortController();
            const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

            try {
                return await fetch(url, {
                    ...options,
                    signal: controller.signal
                });
            } finally {
                window.clearTimeout(timeoutId);
            }
        }

        // --- Verified Add/Update/Checkout Logic ---
        let checkoutSucceeded = false;

        function showCheckoutError(message) {
            let errorBox = document.querySelector('.tft-checkout-error');

            if (!errorBox) {
                errorBox = document.createElement('div');
                errorBox.className = 'tft-checkout-error';
                _.selector.addtocart.parentElement.appendChild(errorBox);
            }

            errorBox.textContent = message;
            errorBox.classList.add('is-visible');

            const overlay = document.querySelector('.tft-checkout-loading');
            if (overlay) overlay.remove();

            if (_.selector.cancelbundle) {
                _.selector.cancelbundle.disabled = false;
            }
        }

        try {
            const clearResponse = await (_.cartPreparationPromise || fetchWithTimeout(
                window.Shopify.routes.root + 'cart/clear.js',
                {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' }
                },
                8000
            ));
            _.cartPreparationPromise = null;

            if (!clearResponse.ok) {
                throw new Error('We could not prepare your cart. Please try again.');
            }

            const addResponse = await fetchWithTimeout(
                window.Shopify.routes.root + 'cart/add.js',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ items: formData.items })
                },
                12000
            );

            const addResult = await addResponse.json().catch(() => ({}));

            if (!addResponse.ok) {
                const shopifyMessage =
                    addResult.description ||
                    addResult.message ||
                    'One of the selected products or plans could not be added.';

                throw new Error(shopifyMessage);
            }

            checkoutSucceeded = true;

            // Use an absolute checkout path so the current page path can never
            // be reused by the browser.
            if (discountCodes.length > 0) {
                // Go directly to checkout with the promotion attached.
                // This avoids Shopify's extra /discount/ redirect.
                window.location.replace(
                    '/checkout?discount=' +
                    encodeURIComponent(discountCodes[0])
                );
            } else {
                window.location.replace('/checkout');
            }

        } catch (error) {
            console.error("Error during add to cart process:", error);
            const message =
                error && error.name === 'AbortError'
                    ? 'Checkout took too long to respond. Please tap the button once more.'
                    : (error && error.message
                        ? error.message
                        : 'We could not begin checkout. Please try again.');
            showCheckoutError(message);
        } finally {
            if (!checkoutSucceeded) {
                _.selector.addtocart.classList.remove("loading");
                _.selector.addtocart.disabled = false;

                const spinner = _.selector.addtocart.querySelector('.loading-spinner');
                if (spinner) spinner.remove();
            }
        }
        // --- End Verified Add/Update/Checkout Logic ---
    }

    GettingStarted = new GettingStarted;
}
GettingStarted();
